<h1 mat-dialog-title class="p-2 text-center">Nouveau Comptage</h1>
<div class="container-fluid p-3">

    <div class="row my-3">
        <mat-form-field class="col">
            <mat-label>Nom</mat-label>
            <input matInput placeholder="Nom" [(ngModel)]="model.CustomName" readonly>
        </mat-form-field>

        <mat-form-field class="col">
            <mat-label>Numero Prélèvement</mat-label>
            <input matInput placeholder="Numero Prélèvement" type="number" [(ngModel)]="model.NumeroPrelevement" readonly>
        </mat-form-field>

        <mat-form-field class="col">
            <mat-label>Quantité (%)</mat-label>
            <input matInput placeholder="Quantité (%)" type="number" [(ngModel)]="model.Quantite" (keyup.enter)="onConfirm()" readonly>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col" cdkFocusRegionEnd>
            <mat-label>Commentaire</mat-label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="3" placeholder="Commentaire" [(ngModel)]="model.Comment" readonly></textarea>
        </mat-form-field>
    </div>

    <div class="row">
        <div class="col-12 col-md-4 my-3" *ngFor="let t of AlreadyPicked">
            <div class="h-100 m-1">
                <div class="border rounded-1 background-light p-3 w-100 d-flex flex-column">
                    <div class="row justify-content-between">
                        <div class="col-1">
                        </div>
                        <div class="col text-center"> {{t.NomFamille}}</div>
                        <div class="col-1">
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deleteTaxon(t)" class="icon-button-small">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="text-center"> {{t.NomGenre}}</div>
                    <div class="text-center fw-bold"> {{t.Quantite}} %</div>
                    <div class="text-center fst-italic"> {{t.Comment}}</div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!ShowNewTaxonForm" class="row my-3 justify-content-center">
        <button appPreventDoubleClick class="col-auto " color="warn" mat-raised-button (throttledClick)="prepareNewTaxon()">
            Identifier un taxon
        </button>
    </div>

    <div *ngIf="ShowNewTaxonForm" class="row">
        <div class="col-12 my-3">
            <div class="h-100 m-1">
                <div class="border rounded-1 background-light p-3 w-100 d-flex flex-column">

                    <div class="row mt-3">
                        <mat-form-field class="col" cdkFocusRegionStart>
                            <mat-label>Recherche Critère faunistique - floristique</mat-label>
                            <input matInput placeholder="Recherche Critère faunistique - floristique" [(ngModel)]="SearchText" [matAutocomplete]="auto" (keyup)="onKeyUp()" [focus]="IsFocused"
                                   (keyup.enter)="onConfirm()">
                            <button appPreventDoubleClick *ngIf="SearchText" matSuffix mat-icon-button aria-label="Clear" (throttledClick)="SearchText=''">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setSelectedTaxon($event)" [displayWith]="displayFn">
                            <mat-option *ngFor="let option of TaxonOptionList" [value]="option">
                                <!-- <span *ngIf="!CoreData.IsOffline">
                    {{option.Code}} - {{option?.Ordre && option?.Ordre !== '' ? option?.Ordre + ' /' : ''}} {{option?.Famille !== '' ? option?.Famille + ' /' : ''}} {{option?.Genre}}
                </span> -->
                                <span>
                                    {{option.Code}} - {{option?.Genre}}
                                </span>
                            </mat-option>
                        </mat-autocomplete>

                        <mat-form-field class="col">
                            <input matInput placeholder="Quantité (%)" type="number" [(ngModel)]="newTaxon.Quantite">
                        </mat-form-field>

                    </div>
                    <div class="row">
                        <mat-form-field class="col" cdkFocusRegionEnd>
                            <mat-label>Commentaire</mat-label>
                            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="3" placeholder="Commentaire" [(ngModel)]="newTaxon.Comment"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="row justify-content-center mb-3">
                        <button appPreventDoubleClick class="col-auto" color="accent" mat-raised-button (throttledClick)="addNewTaxon()" [disabled]="!newTaxon.Code || !newTaxon.Quantite">
                            Ajouter
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <button appPreventDoubleClick class="col-6 squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col-6 squared-flat-button" color="warn" mat-stroked-button (throttledClick)="onConfirm()" [disabled]="!CanAdd">
            Sauvegarder
        </button>
    </div>
</div>